(() => {
  class AccordionController extends Stimulus.Controller {
    static targets = ["button", "item"]
    
    connect() {
      // Get default tab from data attribute or fallback to 0
      const defaultTab = parseInt(this.element.dataset.accordionDefaultTab || 0);
      
      // Initialize with default tab open
      this.openTab(defaultTab);
      
      // Setup aria attributes for accessibility
      this.setupAccessibility(defaultTab);
    }
    
    setupAccessibility(activeIndex) {
      // Create unique IDs for this instance
      const instanceId = `tabs-${Date.now()}`;
      
      // Add ARIA roles and relationships
      this.element.setAttribute('role', 'tablist');
      
      this.buttonTargets.forEach((button, index) => {
        // Set tab attributes
        button.setAttribute('role', 'tab');
        button.setAttribute('id', `${instanceId}-tab-${index}`);
        button.setAttribute('aria-selected', index === activeIndex);
        button.setAttribute('aria-controls', `${instanceId}-panel-${index}`);
        button.setAttribute('tabindex', index === activeIndex ? '0' : '-1');
        
        // Add keyboard navigation
        button.addEventListener('keydown', (event) => this.handleKeyDown(event, index));
      });
      
      this.itemTargets.forEach((panel, index) => {
        // Set panel attributes
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('id', `${instanceId}-panel-${index}`);
        panel.setAttribute('aria-labelledby', `${instanceId}-tab-${index}`);
        panel.setAttribute('tabindex', '0');
        panel.setAttribute('aria-hidden', index !== activeIndex);
      });
    }
    
    handleKeyDown(event, index) {
      let newIndex;
      
      // Handle arrow key navigation
      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          newIndex = (index + 1) % this.buttonTargets.length;
          event.preventDefault();
          break;
          
        case 'ArrowLeft':
        case 'ArrowUp':
          newIndex = (index - 1 + this.buttonTargets.length) % this.buttonTargets.length;
          event.preventDefault();
          break;
          
        case 'Home':
          newIndex = 0;
          event.preventDefault();
          break;
          
        case 'End':
          newIndex = this.buttonTargets.length - 1;
          event.preventDefault();
          break;
          
        case 'Enter':
        case ' ':
          this.openTab(index);
          this.buttonTargets[index].focus();
          event.preventDefault();
          return;
          
        default:
          return;
      }
      
      // Focus the new tab and activate it
      this.buttonTargets[newIndex].focus();
      this.openTab(newIndex);
    }
    
    toggle(event) {
      const targetItem = parseInt(event.currentTarget.dataset.targetItem);
      if (isNaN(targetItem)) return;
      
      this.openTab(targetItem);
      event.preventDefault();
    }
    
    openTab(index) {
      // Reset all buttons and items
      this.buttonTargets.forEach((button, i) => {
        const isActive = i === index;
        button.classList.toggle('active', isActive);
        button.setAttribute('aria-selected', isActive);
        button.setAttribute('tabindex', isActive ? '0' : '-1');
      });

        // Handle mobile buttons separately (direct approach)
      const allMobileButtons = document.querySelectorAll('.tab-button.d-lg-none');
      allMobileButtons.forEach((mobileButton, i) => {
        const isActive = i === index;
        // Update the mobile button
        mobileButton.classList.toggle('active', isActive);
        
        // Update the link inside
        const linkInside = mobileButton.querySelector('a');
        if (linkInside) {
          linkInside.classList.toggle('active', isActive);
        }
        
        // Update the arrow
        const arrowElement = mobileButton.querySelector('.tab-arrow');
        if (arrowElement) {
          arrowElement.style.transform = isActive ? 'rotate(180deg)' : '';
        }
      });

      
      
   // Handle tab content (existing code)
   this.itemTargets.forEach((item, i) => {
    const isActive = i === index;
    item.classList.toggle('active', isActive);
    item.setAttribute('aria-hidden', !isActive);
    
    // Handle accordion behavior on mobile
    if (window.innerWidth < 992) {
      if (isActive) {
        // Calculate height for smooth animation
        const innerContent = item.querySelector('.tab-content-inner');
        if (innerContent) {
          const contentHeight = innerContent.offsetHeight;
          item.style.maxHeight = contentHeight + 'px';
        }
      } else {
        item.style.maxHeight = '0px';
      }
    } else {
      // Desktop behavior
      item.style.maxHeight = '';
    }
  });
      
      // Remember the last selected tab in local storage
      try {
        localStorage.setItem('lastActiveTab', index.toString());
      } catch (e) {
        // Ignore storage errors
      }
      
      // Dispatch an event that other components can listen for
      this.element.dispatchEvent(new CustomEvent('tab:changed', {
        detail: { tabIndex: index }
      }));
    }
  }

  // Register controller when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    if (window.StimulusApp) {
      window.StimulusApp.register("accordion", AccordionController);
    } else if (window.Stimulus && window.Stimulus.Application) {
      // For different Stimulus configurations
      const application = window.Stimulus.Application.defaultApplication;
      if (application) {
        application.register("accordion", AccordionController);
      } else {
        console.error('Stimulus application instance not found');
      }
    } else {
      console.error('Stimulus not found');
    }
  });
})();